// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Meta from 'vue-meta'
import httpWrapper from '@/utils/httpWrapper'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'lib-flexible'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$http = httpWrapper
Vue.use(Meta)
Vue.use(Element)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js